import { getApiInstance } from '../helpers';

const getBookingInfo = (bookingNo: string) => {
  return getApiInstance()
    .post('/booking/info', { bookingNo })
    .then((res) => {
      console.info('/booking/info result', res);
      // for testing canceled
      // const mockedData = {
      //   ...res.data,
      //   bookings: res.data.bookings.map((b) => ({
      //     ...b,
      //     data: {
      //       ...b.data,
      //       bookingStatusCode: 'X',
      //     },
      //   })),
      // };

      // for testing opusError and shineError
      // return {
      //   ...res.data,
      //   bookings: res.data.bookings.map((b) => {
      //     if (b.bookingNo === 'TA2PY2415802') {
      //       return {
      //         ...b,
      //         opusError: true,
      //       };
      //     } else if (b.bookingNo === 'TA2PY2415803') {
      //       return {
      //         ...b,
      //         shineError: true,
      //       };
      //     } else if (b.bookingNo === 'TA2PY2415804') {
      //       return {
      //         ...b,
      //         opusError: true,
      //         shineError: true,
      //       };
      //     }
      //     return b;
      //   }),
      // };

      return res.data;
    });
};

const getManyBookingInfo = (bookingNos: string[]) => {
  return getApiInstance()
    .post('/booking/info', { bookingNo: bookingNos })
    .then((res) => {
      console.info('many /booking/info result', res);
      // for testing found
      // const mockedData = {
      //   ...res.data,
      //   bookings: res.data.bookings.map((b) => ({
      //     ...b,
      //     opusFound: false,
      //   })),
      // };
      // return mockedData;
      // for testing opusError and shineError
      // return {
      //   ...res.data,
      //   bookings: res.data.bookings.map((b) => {
      //     if (b.bookingNo === 'TA2PY2415802') {
      //       return {
      //         ...b,
      //         opusError: true,
      //       };
      //     } else if (b.bookingNo === 'TA2PY2415803') {
      //       return {
      //         ...b,
      //         shineError: true,
      //       };
      //     } else if (b.bookingNo === 'TA2PY2415804') {
      //       return {
      //         ...b,
      //         opusError: true,
      //         shineError: true,
      //       };
      //     }
      //     return b;
      //   }),
      // };
      return res.data;
    });
};

export const bookingInfoService = {
  getBookingInfo,
  getManyBookingInfo,
};
